import { Component, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { AgentService } from '../services/agent.service';
import { Location } from '@angular/common';
import { AgentReviewStepFormHandlerComponent } from './agent-review-step-from.handler';

@Component({
  selector: 'sym-agent-review-step-form',
  templateUrl: './agent-review-step-form.component.html',
  styleUrls: ['./agent-review-step-form.component.scss'],
})
export class AgentReviewStepFormComponent extends AgentReviewStepFormHandlerComponent {
  constructor(
    service: AgentService,
    route: ActivatedRoute,
    router: Router,
    location: Location,
    settingService: SettingService,
    headerService: HeaderService
  ) {
    super(service, route, router, location, settingService, headerService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
